import React from 'react';
// mui components
import { Box, Tooltip, Typography } from '@mui/material';
// draft-js-plugins types
import { SubMentionComponentProps } from '@draft-js-plugins/mention/lib/Mention';

const Mention: React.FC<SubMentionComponentProps> = (props) => {
  const disabled = props.mention?.disabled;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0 2px',
        borderRadius: '8px',
        opacity: disabled ? '0.5' : '1',
        background: '#E7ECFF',
        verticalAlign: 'middle',
      }}
    >
      <Tooltip
        title={disabled ? 'Not in audience' : ''}
        disableHoverListener={!disabled}
        disableFocusListener={!disabled}
        disableTouchListener={!disabled}
      >
        <Typography
          component="span"
          sx={{
            display: 'inline',
            verticalAlign: 'middle',
            fontFamily: 'Inter',
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '146%',
            color: '#3652C6',
          }}
        >
          {props.decoratedText}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default Mention;
